<template>
  <div class="qzfooter">
    <div class="fwlSty">
      访问量&nbsp;&nbsp;&nbsp;&nbsp;
      <span class="footerRect" v-for="(item,index) in count1" :key="index">{{item}}</span>
    </div>
    <div class="footerInfow">
      <div class="footerInfo">
        <div v-for="(item,index) in itemList" :key="index" class="footerInfo1" @click="toTop(item)">{{item.name}}</div>
      </div>
    </div>
    <div style="display: flex;justify-content: center;margin-top: 0.45rem;margin-bottom: 0.225rem;">
      <div style="flex:0 0 1.5rem">
        <img src="@/assets/image/wxgzh.png" style="width:1.5rem;height: 1.5rem;">
        <div style="font-size: 0.15rem;text-align:center;font-family: Microsoft YaHei;font-weight: 400;color: #A7A7A7;">微信公众号</div>
      </div>
      <div style="flex:0 0 1.5rem;margin-left: 0.375rem;">
        <img src="@/assets/image/wxxcx.png" style="width:1.5rem;height: 1.5rem;">
        <div style="font-size: 0.15rem;font-family: Microsoft YaHei;font-weight: 400;color: #A7A7A7;text-align:center">微信小程序</div>
      </div>
    </div>
    <div style="width:100%;text-align:center;font-size: 0.175rem;font-family: Microsoft YaHei;font-weight: 400;color: #A7A7A7;opacity: 1;"> 泉州市科技馆：泉州市丰泽区府西路 泉州市科技与规划馆，邮编：362000，联系我们：0595-22556656 </div>
    <div style="width:100%;text-align:center;margin-top: 0.1rem;margin-bottom: 0.225rem;font-weight: 400;color: #A7A7A7;opacity: 1;"> Copyright © 2010-2019 泉州市科技馆，闽iCP备:11002482号 </div>
    <div style="background: #1C1C1C;width:100%;text-align:center;font-size: 0.175rem;font-family: Microsoft YaHei;font-weight: 400;color: #A7A7A7;opacity: 1;">技术支持：泉州市日海科技传播有限公司</div>
  </div>
</template>

<script>
  import Cookies from 'js-cookie'
import {getMe} from '@/api/login.js'
import {viewCount} from '@/api/index/index.js'
export default {
  name: "app",
  data() {
    return {
      count:0,
      count1:[0],
      itemList:[
        {id:1,name:'首页',src:'Home'},
        {id:2,name:'场馆概况',src:'Overview'},
        {id:3,name:'展览导航',src:'Navigation'},
        {id:4,name:'科普知识',src:'Knowledge'},
        {id:5,name:'信息资讯',src:'Information'},
        {id:6,name:'服务咨询',src:'Consult'},
        {id:9,name:'专题专栏',src:'PartyInfo'},
        // {id:7,name:'展教活动',src:'EduActivity'},
        // {id:8,name:'特效影院',src:'Cinema'},
        // {id:9,name:'青少年科教',src:'Home'},
        // {id:10,name:'流动科技馆',src:'Home'},
      ]
    };
  },
  created(){
    let that=this
    if(localStorage.getItem('count')){
      this.count=localStorage.getItem('count')
      this.count1=this.count.toString().split('')
    }
    window.addEventListener('load',function(){
      that.viewCount()
    })
  },
  methods:{
    viewCount(){
      viewCount().then(res=>{
        if(res.data.code==0){
          this.count=res.data.count
          this.count1=this.count.toString().split('')
          localStorage.setItem('count',this.count)
        }
      })
    },
    toTop(item){
      if(item.id==7||item.id==8){
        if(Cookies.get('userInfo')){
          if(!JSON.parse(Cookies.get('userInfo')).token){
            this.$message.success('请先登录再操作')
            // setTimeout(()=>{
              this.$router.push('/login')
            // },1000)
          }else{
            // getMe().then(res=>{
            //   if(res.data.code=='0'){
                this.$router.push({name:item.src})
            //   }else if(res.data.code=='403'){
            //     Cookies.remove('userInfo')
            //     Cookies.remove('userAllInfo')
            //     this.$message.success('请先登录再操作')
            //     // setTimeout(()=>{
            //       this.$router.push('/login')
            //     // },1000)
            //   }else{
            //     Cookies.remove('userInfo')
            //     Cookies.remove('userAllInfo')
            //     this.$message.success('请先登录再操作')
            //     // setTimeout(()=>{
            //       this.$router.push('/login')
            //     // },1000)
            //   }
            // })
          }
        }else{
          this.$message.success('请先登录再操作')
          // setTimeout(()=>{
            this.$router.push('/login')
          // },1000)
        }
      }else{
        this.$router.push({name:item.src})
      }
    },

  },
}
</script>

<style lang="less" scoped>
  .footerInfow{
    width: 18rem;
    margin: 0 auto;
    box-sizing: border-box;
  }
  .footerInfo{
    display:flex;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 0 0 0.25rem 0;
    border-bottom:1px solid rgba(255,255,255,.2);
  }
  .footerInfo1{
    cursor: pointer;
    // flex:0 0 1.375rem;
    margin-right: 0.7375rem;
    font-size: 0.225rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(255,255,255,.7)
  }
  .footerInfo1:last-child{
    margin-right: 0;
  }
  .footerInfo1:hover{
    color: #fff;
  }
  .qzfooter{
    width: 100%;
    height: 4.975rem;
    padding-bottom: 0.225rem;
    padding-top: 0.1625rem;
    background: #1C1C1C;
  }
  .fwlSty{
    margin-bottom: 0.4125rem;
    font-size: 0.225rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
    span{
      display: inline-block;
      width: 0.3125rem;
      height: 0.4375rem;
      line-height: 0.4375rem;
      text-align: center;
      background: #474747;
      margin-right: 0.05rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue